export default function () {
  const widgetName = 'footerNavItems';
  const widgetOpts = footerNavItemsOpts;

  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    maxItemsVisible: 7,
    itemsPerPanel: 7,
    showDescription: false,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length == 0) {
        $(`#${widgetName}`).remove();
      } else {
        $('.footer .footer-navigation').remove();
        customFooterItems(widgetData);
      }
    },
  });

  function customFooterItems(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Title, URL } = widgetData[x];

      const $item = $(this);

      $widget.addClass('footer-navigation');

      if (URL !== null) {
        $item.replaceWith(
          `<li class="footer-navigation__item">
          <a href="${URL}" class="footer-navigation__link">${Title}</a>
          </li>`,
        );
      } else {
        $item.remove();
      }
    });
  }
}
